<template>
    <div>
        <van-tabs type="card" color="#07C160" sticky :offset-top="100">
            <van-tab style="margin-top: 10px" title="初审报告">
                <van-divider>业务概要</van-divider>
                <van-cell-group>
                    <van-field
                        clearable
                        label="当前抵押权人"
                        name="currentMortgagePerson"
                        placeholder="请输入当前抵押权人"
                        right-icon="records"
                        v-model="form.currentMortgagePerson"
                        :readonly="isReadOnly"
                        required
                    />
                    <van-field
                        clearable
                        label="对应负债余额"
                        name="currentMortgageAmount"
                        placeholder="请输入当前对应负债余额"
                        right-icon="records"
                        v-model="form.currentMortgageAmount"
                        :readonly="isReadOnly"
                        required
                    />
                    <van-field
                        clearable
                        label="是否需要结清"
                        name="settlementIsRequired"
                        placeholder="是否需要结清"
                        right-icon="records"
                        v-model="form.settlementIsRequired"
                        :readonly="isReadOnly"
                        required
                        @click-right-icon="showPopup('settlementIsRequired')"
                    />
                  <van-field
                      clearable
                      label="是否关联大橙垫资"
                      name="associatedAdvances"
                      placeholder="是否关联大橙垫资"
                      right-icon="records"
                      v-model="form.associatedAdvances"
                      :readonly="isReadOnly"
                      required
                      @click-right-icon="showPopup('associatedAdvances')"
                  />
                  <van-field
                      clearable
                      label="借款用途"
                      name="purposeOfBorrowing"
                      placeholder="请填写借款用途"
                      right-icon="records"
                      v-model="form.purposeOfBorrowing"
                      :readonly="isReadOnly"
                      required
                  />
                  <van-field
                      clearable
                      label="借款原因"
                      name="reasonOfBorrowing"
                      placeholder="请填写借款原因"
                      right-icon="records"
                      v-model="form.reasonOfBorrowing"
                      :readonly="isReadOnly"
                      required
                  />
                  <van-field
                      clearable
                      label="还款来源"
                      name="realRepaySource"
                      placeholder="请填写还款来源"
                      right-icon="records"
                      v-model="form.realRepaySource"
                      :readonly="isReadOnly"
                      required
                  />
                  <van-field
                      clearable
                      label="情况说明"
                      name="businessSummaryFactSheet"
                      placeholder="情况说明"
                      right-icon="records"
                      v-model="form.businessSummaryFactSheet"
                      :readonly="isReadOnly"
                      required
                  />
                </van-cell-group>

                <van-divider>批贷信息</van-divider>
                <van-cell-group>
                  <van-field
                      clearable
                      label="批贷金额"
                      name="approveAmt"
                      placeholder="请输入批贷金额"
                      right-icon="records"
                      v-model="form.approveAmt"
                      :readonly="isReadOnly"
                      required
                  />
                  <van-field
                      clearable
                      label="贷款期限"
                      name="approveNo"
                      placeholder="请输入批贷期限"
                      right-icon="records"
                      v-model="form.approveNo"
                      :readonly="isReadOnly"
                      required
                  />
                  <van-field
                      clearable
                      label="收费标准"
                      name="approveRate"
                      placeholder="请输入收费标准"
                      right-icon="records"
                      v-model="form.approveRate"
                      :readonly="isReadOnly"
                      required
                  />
                  <van-field
                      clearable
                      label="是否公证"
                      name="notarization"
                      placeholder="是否公证"
                      right-icon="records"
                      v-model="form.notarization"
                      :readonly="isReadOnly"
                      required
                      @click-right-icon="showPopup('notarization')"
                  />
                  <van-field
                      clearable
                      label="抵押顺位"
                      name="mortgagePriority"
                      placeholder="请选择抵押顺位"
                      right-icon="records"
                      v-model="form.mortgagePriority"
                      :readonly="isReadOnly"
                      required
                      @click-right-icon="showPopup('mortgagePriority')"
                  />
                </van-cell-group>

                <van-divider>借款人资料</van-divider>
                    <van-cell-group>
                        <van-field
                                clearable
                                label="客户或其他借款人的职业是否为特殊行业"
                                name="industry"
                                placeholder="如是，请说明情况"
                                right-icon="records"
                                v-model="form.industry"
                                :readonly="isReadOnly"
                                required
                                @click-right-icon="showPopup('industry')"
                        />

                        <van-field
                                clearable
                                label="客户或其他借款人是否为外籍或港澳台居民"
                                name="domicile"
                                placeholder="如是，请说明情况"
                                right-icon="records"
                                v-model="form.domicile"
                                :readonly="isReadOnly"
                                required
                                @click-right-icon="showPopup('domicile')"
                        />

                        <van-field
                                clearable
                                label="其他应关注信息"
                                name="customerOther"
                                placeholder="请选择"
                                right-icon="records"
                                v-model="form.customerOther"
                                :readonly="isReadOnly"
                                required
                                @click-right-icon="showPopup('customerOther')"
                        />
                    </van-cell-group>

                    <van-divider>婚姻状况</van-divider>

                    <van-cell-group>
                        <van-field
                                clearable
                                label="客户及其他借款主体当前婚姻状况"
                                name="marriage"
                                placeholder="请选择"
                                right-icon="records"
                                v-model="form.marriage"
                                :readonly="isReadOnly"
                                required
                                @click-right-icon="showPopup('marriage')"
                        />

                        <van-field
                                clearable
                                label="客户是否存在离婚补偿义务"
                                name="compensate"
                                placeholder="请选择"
                                right-icon="records"
                                v-model="form.compensate"
                                :readonly="isReadOnly"
                                required
                                @click-right-icon="showPopup('compensate')"
                        />

                        <van-field
                                clearable
                                label="了解客户是否有子女"
                                name="children"
                                placeholder="请选择"
                                right-icon="records"
                                v-model="form.children"
                                :readonly="isReadOnly"
                                required
                                @click-right-icon="showPopup('children')"
                        />

                        <van-field
                                clearable
                                label="其他应关注信息"
                                name="marriageOther"
                                placeholder="请选择"
                                right-icon="records"
                                v-model="form.marriageOther"
                                :readonly="isReadOnly"
                                required
                                @click-right-icon="showPopup('marriageOther')"
                        />
                    </van-cell-group>

                <van-divider>房产资料</van-divider>

                <template v-for="(item, index) in house">
                    <van-cell-group>
                        <van-cell title="房产地址" :value="`${item.province} ${item.city} ${item.district} ${item.detailedAdress}`">
                            <template #right-icon>
                                <van-button size="small" type="primary" @click="handleEdit(item)" style="margin-left: 20px">编辑</van-button>
                            </template>
                        </van-cell>
                        <van-cell title="小区名称" :value="item.estateName" />
                        <van-cell title="房屋面积" :value="item.houseArea" />
                        <van-cell title="房屋楼层" :value="item.floor" />
                        <van-cell title="房龄" :value="item.hourseAge | filterHouseAgeText" />
                        <van-cell title="取得时间" :value="item.purchaseDate | day" />
                        <van-cell title="产权类型" :value="item.propertyType | filterHouseTypeText" />
                    </van-cell-group>

<!--                    <van-field-->
<!--                            label="担保责任本金"-->
<!--                            :v-model="form['house_'.concat(item.customerHouseId).concat('_loan_guarantee')]"-->
<!--                            placeholder=""-->
<!--                            type="number"-->
<!--                            :formatter="value => `${value}`"-->
<!--                            required-->
<!--                    >-->
<!--                    </van-field>-->

                    <van-field
                            label="产权归属"
                            v-model="form['house_'.concat(item.customerHouseId).concat('_propertyDesc')]"
                            placeholder="如为共同共有、按份共有，请说明共有人与客户关系，并确认全部共有人已签署共借；"
                            :autosize="{ minHeight: 60, maxHeight: 100 }"
                            required
                            :readonly="isReadOnly"
                            @click-right-icon="showOtherPopup('propertyDesc','house_'.concat(item.customerHouseId).concat('_propertyDesc'))"
                    />

                    <van-field
                            label="客户房产来源"
                            right-icon="records"
                            v-model="form['house_'.concat(item.customerHouseId).concat('_source')]"
                            placeholder="如不是通过购买所得，请说明客户是否已合法取得房屋所有权；"
                            required
                            :readonly="isReadOnly"
                            @click-right-icon="showOtherPopup('source','house_'.concat(item.customerHouseId).concat('_source'))"
                    >
                    </van-field>

                    <van-field
                        label="客户房产性质"
                        right-icon="records"
                        v-model="form['house_'.concat(item.customerHouseId).concat('_quality')]"
                        placeholder="确认客户房产性质，如不是商品房，请说明是否可以正常交易"
                        required
                        :readonly="isReadOnly"
                        @click-right-icon="showOtherPopup('quality','house_'.concat(item.customerHouseId).concat('_quality'))"
                    >
                    </van-field>

                    <!-- 是否出租 合同打印值 -->
                    <van-field
                            label="是否出租【合同打印取值】"
                            right-icon="records"
                            v-model="form['house_'.concat(item.customerHouseId).concat('_isLease')]"
                            placeholder="请选择是否出租"
                            required
                            :readonly="isReadOnly"
                            @click-right-icon="showOtherPopup('isLease','house_'.concat(item.customerHouseId).concat('_isLease'))"
                    >
                    </van-field>


                    <!-- 出租情况说明 -->
                    <van-field
                            label="出租情况说明"
                            v-model="form['house_'.concat(item.customerHouseId).concat('_lease')]"
                            placeholder="房屋当前是否有租约？如有，请说明情况（租赁期间、租金水平、是否群租）；如无出租请填写无"
                            type="textarea"
                            :autosize="{ minHeight: 60, maxHeight: 100 }"
                            required
                    />

                    <!-- 是否有老人或小孩居住 -->
                    <van-field
                            label="是否有老人或小孩居住"
                            v-model="form['house_'.concat(item.customerHouseId).concat('_live')]"
                            placeholder="请输入或者选择右侧模板确认房屋当前是否有老人或小孩居住？如有，请说明情况；"
                            required
                            right-icon="records"
                            @click-right-icon="showOtherPopup('live','house_'.concat(item.customerHouseId).concat('_live'))"
                    >
                    </van-field>

                    <!-- 装修状态 -->
                    <van-cell title="装修状态" :value="item.decorate | filterHouseDecorateText" />

                    <!-- 下户意见说明 -->
                    <van-field
                            label="下户意见说明"
                            v-model="form['house_'.concat(item.customerHouseId).concat('_survey')]"
                            placeholder="房屋当前装修状态；如有其他重要下户意见请说明；"
                            type="textarea"
                            :autosize="{ minHeight: 60, maxHeight: 100 }"
                            required
                    />

                    <!-- 有无其他房产 -->
                    <van-field
                            label="在京有无其他不动产信息"
                            v-model="form['house_'.concat(item.customerHouseId).concat('_only')]"
                            placeholder="在京有无其他不动产信息？如果有，请说明情况（房产情况、抵押金额及日期）；"
                            required
                            right-icon="records"
                            @click-right-icon="showOtherPopup('onlyHouse','house_'.concat(item.customerHouseId).concat('_only'))"
                    >
                    </van-field>

                    <!-- 其他应关注信息 -->
                    <van-field
                            label="其他应关注信息"
                            v-model="form['house_'.concat(item.customerHouseId).concat('_other')]"
                            placeholder="请输入或者选择右侧模板"
                            required
                            right-icon="records"
                            @click-right-icon="showOtherPopup('otherConcerns','house_'.concat(item.customerHouseId).concat('_other'))"
                    >
                    </van-field>
                </template>

                <van-divider>估值数据(所有抵押物汇总计算)</van-divider>
                <van-cell-group>
                    <van-field
                            label="世联评估值(万)"
                            name="estimatePriceBySL"
                            placeholder="请输入世联评估值"
                            v-model="form.estimatePriceBySL"
                            clearable
                            @change="(e) => calculateAverage(e.target.value, 'estimatePriceBySL')"
                    />

                    <van-field
                            label="房估估评估值(万)"
                            name="estimatePriceByFgg"
                            placeholder="请输入房估估评估值"
                            v-model="form.estimatePriceByFgg"
                            clearable
                            @change="(e) => calculateAverage(e.target.value, 'estimatePriceByFgg')"
                    />

                    <van-field
                            label="快出价(万)"
                            name="estimatePriceByFast"
                            placeholder="请输入快出价"
                            v-model="form.estimatePriceByFast"
                            clearable
                            @change="(e) => calculateAverage(e.target.value, 'estimatePriceByFast')"
                    />
                </van-cell-group>

                <van-cell-group>
                    <van-field
                            label="综合评估价(万，信托)"
                            name="finalPrice"
                            placeholder="请输入综合评估价"
                            v-model="form.finalPrice"
                            clearable
                    />

                    <van-field
                            label="评估平均数(万)"
                            name="estimatePriceAverage"
                            placeholder="评估平均数"
                            v-model="form.estimatePriceAverage"
                            clearable
                    />

                    <van-field
                            label="抵押率(%)"
                            name="customMortgageRate"
                            placeholder="请输入抵押率"
                            v-model="form.customMortgageRate"
                            clearable
                            :maxlength="100"
                            @change="(e) => calculateLimit(e.target.value, 'customMortgageRate')"
                    />
                </van-cell-group>

                <van-cell-group>
                    <van-field
                            label="贷款对应房产估值(万)"
                            name="estimatePrice"
                            placeholder="贷款对应房产估值"
                            v-model="form.estimatePrice"
                            clearable
                            disabled
                    />

                    <van-field
                            label="一押余额(元)"
                            name="bankLoanBalance"
                            placeholder="请输入一押余额"
                            v-model="form.bankLoanBalance"
                            clearable
                            @change="(e) => calculateLimit(e.target.value, 'bankLoanBalance')"
                    />

                    <van-field
                            label="放款额度上限(万)"
                            name="approveAmountLimit"
                            placeholder="放款额度上限"
                            v-model="form.approveAmountLimit"
                            clearable
                            disabled
                    />

                    <van-field
                            label="抵押合同抵押率(%)"
                            name="mortgageRateContract"
                            placeholder="请输入抵押合同抵押率"
                            v-model="form.mortgageRateContract"
                            clearable
                            :maxlength="100"
                    />
                </van-cell-group>

                <van-divider>征信报告</van-divider>
                <van-cell-group>
                    <!-- 批贷金额 -->
                    <van-field
                            label="橙易贷金额(元)"
                            name="approveAmt"
                            placeholder="请输入批贷金额"
                            v-model="form.approveAmt"
                            type="number"
                            clearable
                            @change="(e) => calculateDebt(e.target.value, 'approveAmt')"
                    />

                    <!-- 信贷余额 -->
                    <van-field
                            label="信贷余额(元)"
                            name="creditAmount"
                            placeholder="请输入信贷余额"
                            v-model="form.creditAmount"
                            type="number"
                            clearable
                            @change="(e) => calculateDebt(e.target.value, 'creditAmount')"
                    />
                </van-cell-group>

                <van-cell-group>
                    <!-- 信用卡余额 -->
                    <van-field
                            label="信用卡余额(元)"
                            name="creditCardAmount"
                            placeholder="请输入信用卡余额"
                            type="number"
                            v-model="form.creditCardAmount"
                            clearable
                            @change="(e) => calculateDebt(e.target.value, 'creditCardAmount')"
                    />

                    <!-- 在京备房抵押贷款余额 -->
                    <van-field
                            label="在京备房抵押贷款余额(元)"
                            name="bankBalanceInBj"
                            placeholder="请输入在京备房抵押贷款余额"
                            type="number"
                            v-model="form.bankBalanceInBj"
                            clearable
                            @change="(e) => calculateDebt(e.target.value, 'bankBalanceInBj')"
                    />
                </van-cell-group>

                <van-cell-group>

                    <!-- 其他负债 -->
                    <van-field
                        label="一抵贷款余额"
                        name="bankLoanBalance"
                        placeholder="一抵贷款余额"
                        type="number"
                        v-model="form.bankLoanBalance"
                        clearable
                        @change="(e) => calculateDebt(e.target.value, 'bankLoanBalance')"
                    />

                    <!-- 其他负债 -->
                    <van-field
                            label="其他负债(元)"
                            name="otherAmount"
                            placeholder="请输入其他负债"
                            type="number"
                            v-model="form.otherAmount"
                            clearable
                            @change="(e) => calculateDebt(e.target.value, 'otherAmount')"
                    />

                    <!-- 在京备房评估值 -->
                    <van-field
                            label="在京备房评估值(元)"
                            name="estimateOther"
                            placeholder="请输入在京备房评估值"
                            type="number"
                            v-model="form.estimateOther"
                            clearable
                            @change="(e) => calculateDebt(e.target.value, 'estimateOther')"
                    />
                </van-cell-group>

                <van-cell-group>
                    <!-- 资产负债率 -->
                    <van-field
                            label="资产负债率(%)"
                            name="debt"
                            type="number"
                            placeholder="资产负债率"
                            v-model="form.debt"
                            clearable
                            disabled
                    />
                </van-cell-group>
                <van-cell-group>
                    <!-- 客户及共借人是否有当前逾期的情形 -->
                    <van-field
                            clearable
                            label="客户及共借人是否有当前逾期的情形"
                            name="overdue"
                            placeholder="请输入或者选择右侧模板"
                            v-model="form.overdue"
                            :readonly="isReadOnly"
                            right-icon="records"
                            @click-right-icon="showPopup('overdue')"
                    >
                    </van-field>

                    <!-- 客户及共借人近一年内是否有超出连3的情况 -->
                    <van-field
                            clearable
                            label="客户及共借人近一年内是否有超出连3的情况"
                            name="moreThan3"
                            placeholder="请输入或者选择右侧模板"
                            v-model="form.moreThan3"
                            :readonly="isReadOnly"
                            right-icon="records"
                            @click-right-icon="showPopup('moreThan3')"
                    >
                    </van-field>

                    <!-- 是否有呆账、冻结、关注、次级、可疑、代偿等信息 -->
                    <van-field
                            clearable
                            label="是否有呆账、冻结、关注、次级、可疑、代偿等信息"
                            name="abnormal"
                            placeholder="请输入或者选择右侧模板"
                            v-model="form.abnormal"
                            :readonly="isReadOnly"
                            right-icon="records"
                            @click-right-icon="showPopup('abnormal')"
                    >
                    </van-field>

                    <!-- 其他应关注信息 -->
                    <van-field
                            clearable
                            label="其他应关注信息"
                            name="creditOther"
                            placeholder="请输入或者选择右侧模板"
                            v-model="form.creditOther"
                            :readonly="isReadOnly"
                            right-icon="records"
                            @click-right-icon="showPopup('creditOther')"
                    >
                    </van-field>
                </van-cell-group>

                <van-divider content-position="left">司法查询</van-divider>

                <van-field
                        v-model="form.defendant"
                        label="客户及共借人是否有涉及借贷纠纷被告"
                        placeholder="请输入或者选择"
                        required
                        right-icon="records"
                        @click="showPopup('defendant')"
                >
                    <template #right-icon>
                        <van-icon name="records" />
                    </template>
                </van-field>

                <van-field
                        v-model="form.plaintiff"
                        label="客户及共借人是否有涉及借贷纠纷原告"
                        placeholder="请输入或者选择"
                        required
                        right-icon="records"
                        @click="showPopup('plaintiff')"
                >
                    <template #right-icon>
                        <van-icon name="records" />
                    </template>
                </van-field>

                <van-field
                        v-model="form.execute"
                        label="客户及共借人当前是否有涉诉或被执行信息（非借贷纠纷）"
                        placeholder="请输入或者选择"
                        required
                        right-icon="records"
                        @click="showPopup('execute')"
                >
                    <template #right-icon>
                        <van-icon name="records" />
                    </template>
                </van-field>

                <van-field
                        v-model="form.economy"
                        label="客户经营主体及关联公司是否有经济纠纷"
                        placeholder="请输入或者选择"
                        required
                        right-icon="records"
                        @click="showPopup('economy')"
                >
                    <template #right-icon>
                        <van-icon name="records" />
                    </template>
                </van-field>

                <van-field
                        v-model="form.judicialOther"
                        label="其他应关注信息"
                        placeholder="请输入或者选择"
                        required
                        right-icon="records"
                        @click="showPopup('judicialOther')"
                >
                    <template #right-icon>
                        <van-icon name="records" />
                    </template>
                </van-field>

                <van-divider content-position="center">提还违约金</van-divider>

                <van-cell-group v-for="index in 5" :key="`prepay-rule-${index}`">
                    <van-field
                            v-model="form[`prepay_rule${index}_month`]"
                            :label="`提还期限${index === 5 ? '超过' : '内(含)'}`"
                            placeholder="请输入月份"
                            required
                    />
                    <van-field
                            v-if="index !== 5"
                            v-model="form[`prepay_rule${index}_ratio`]"
                            label="违约金(提前还款金额)比例"
                            placeholder="请输入违约金收取比例"
                            required
                    />
                    <template v-else>
                        <span style="color: rgba(0, 0, 0, 0.85)">无需支付提前还款违约金</span>
                    </template>
                </van-cell-group>

                <van-field
                        clearable
                        label="贷款合同是否申请强执公证"
                        placeholder="请输入或者选择"
                        v-model="form.notarization"
                        required
                        :readonly="isReadOnly"
                        right-icon="records"
                        @click="showPopup('notarization')"
                >
                </van-field>

                <van-divider>审批意见</van-divider>

                <van-field
                        clearable
                        label="风控内勤审核意见；是否需要客户补充其他资料"
                        v-model="form.riskAudit"
                        placeholder="请输入或选择"
                        required
                        :readonly="isReadOnly"
                        right-icon="records"
                        @click="showPopup('riskAudit')"
                >
                </van-field>

                <van-field
                        clearable
                        label="审核人的审批意见；是否为附条件审批"
                        v-model="form.audit"
                        placeholder="请输入或选择"
                        required
                        :readonly="isReadOnly"
                        right-icon="records"
                        @click="showPopup('audit')"
                >
                </van-field>

                <van-field
                        clearable
                        label="橙易贷专员的审批意见"
                        v-model="form.assistantAudit"
                        placeholder="请输入或选择"
                        required
                        :readonly="isReadOnly"
                        right-icon="records"
                        @click="showPopup('assistantAudit')"
                >
                </van-field>

                <van-field
                        clearable
                        label="运营后续跟进是否有应注意事项"
                        v-model="form.operateAudit"
                        placeholder="请输入或选择"
                        required
                        :readonly="isReadOnly"
                        right-icon="records"
                        @click="showPopup('operateAudit')"
                >
                </van-field>
                <div style="margin: 16px;">
                    <van-row gutter="20">
                        <template v-if="!isReadOnly">
                            <van-col span="8" >
                                <van-button round block  type="default" native-type="submit" size="small" @click="handleSaveCache">
                                    临时保存
                                </van-button>
                            </van-col>
                            <van-col span="8" v-if="!isReadOnly">
                                <van-button round block  type="default" native-type="submit" size="small" @click="handleLoadCache">
                                    读取临时保存内容
                                </van-button>
                            </van-col>
                            <van-col span="8">
                                <van-button round block :loading="loading" type="info" native-type="submit" size="small" @click="saveOpinion">
                                    保存初审报告
                                </van-button>
                            </van-col>
                        </template>
                        <template v-else>
                            <van-col span="24">
                                <van-button round block  size="small">
                                    返回
                                </van-button>
                            </van-col>
                        </template>


                    </van-row>
                </div>



            </van-tab>
            <van-tab style="margin-top: 10px" title="初审附件">
                <van-collapse v-model="activeNames">
                    <van-collapse-item title="终审附件" name="5">
                        <oss-upload :applyId="applyId" :groupCode="70" refName="zsfj" :isUpload="!read"></oss-upload>
                    </van-collapse-item>
                    <van-collapse-item title="风控评估依据" name="5">
                        <oss-upload :applyId="applyId" :groupCode="501" refName="fkpgyj" :isUpload="!read"></oss-upload>
                    </van-collapse-item>
                </van-collapse>

            </van-tab>
        </van-tabs>

        <!-- 终审审批通过 -->
        <van-popup v-model="showRiskAudit" position="right" style="width: 100%;height: 100%">
            <van-row style="padding-bottom: 47px">
                <van-nav-bar fixed left-arrow left-text="返回" title="风控审批通过" @click-left="showRiskAudit = false">
                </van-nav-bar>
            </van-row>
            <van-field label="申请金额" type="number" readonly v-model="riskFinalForm.borrowAmount" />

            <van-field label="审批金额" type="number" v-model="riskFinalForm.approveAmt" clearable
                :error-message="approveAmtErr" placeholder="请输入" />

            <van-field label="资金提供方" type="text" readonly v-model="supplierValue" :error-message="supplierErr"
                @click="supplierShow = true" placeholder="请选择" />

            <van-field label="资金包" type="text" readonly v-model="productCapitalName" @click="productCapitalShow = true"
                placeholder="请选择" />

            <van-field label="资金方产品" type="text" readonly v-model="supplierProductName"
                @click="supplierProductShow = true" placeholder="请选择" />

            <van-field label="匹配产品利率" type="text" v-model="suitableRate" @click="suitableShow = true" readonly
                placeholder="请选择" />

            <van-field label="年利率%" v-if="applyInfo.productFlag != '1100110'" type="number"
                v-model="riskFinalForm.approveRate" clearable :error-message="approveRateErr" placeholder="请输入" />

            <van-field label="上浮利率%" type="number" v-model="riskFinalForm.floatRate" clearable
                :error-message="floatRateErr" placeholder="请输入" />

            <van-field label="本次放款" type="number" v-model="riskFinalForm.advanceAmount" clearable
                :error-message="advanceAmountErr" placeholder="请输入" />

            <van-field label="申请期限" type="number" readonly v-model="riskFinalForm.borrowTerm" placeholder="请输入" />

            <van-field label="审批期限" type="number" v-model="riskFinalForm.approveNo" clearable
                :error-message="approveNoErr" placeholder="请输入" />

            <van-field label="还款方式" type="text" readonly v-model="repayModeCn" :error-message="repayModeErr"
                @click="repayModeShow = true" placeholder="请输入" />

            <van-field label="借款日利率%" v-if="applyInfo.productFlag == '1100110'" type="number"
                v-model="riskFinalForm.dayRate" clearable :error-message="dayRateErr" placeholder="请输入" />

            <van-field name="radio" label="是否标准单">
                <template #input>
                    <van-radio-group v-model="riskFinalForm.standardFlag" direction="horizontal">
                        <van-radio name="true">是</van-radio>
                        <van-radio name="false">否</van-radio>
                    </van-radio-group>
                </template>
            </van-field>


            <van-popup v-model="suitableShow" position="bottom" :overlay="false">
                <van-picker title="匹配产品利率" show-toolbar :columns="selectProduct" @cancel="suitableShow = false"
                    @confirm="confirmSuitableProduct" />
            </van-popup>

            <van-field type="textarea" size="large" v-model="riskFinalForm.remark" clearable :error-message="remarkErr"
                placeholder="请输入审批意见" />
            <van-row style="text-align: center">
                <van-button style="margin-left: 10px" type="primary" size="small" :loading="loading"
                    @click="auditRiskFinal(1)">提交到风控复审</van-button>
            </van-row>

            <van-popup v-model="supplierShow" position="bottom" :overlay="false">
                <van-picker title="资金提供方" show-toolbar :columns="selectSupplier" @cancel="supplierShow = false"
                    @confirm="confirmSupplier" />
            </van-popup>

            <van-popup v-model="productCapitalShow" position="bottom" :overlay="false">
                <van-picker title="资金包" show-toolbar :columns="selectCapital" @cancel="productCapitalShow = false"
                    @confirm="confirmCapital" />
            </van-popup>


            <van-popup v-model="supplierProductShow" position="bottom" :overlay="false">
                <van-picker title="资金方产品" show-toolbar :columns="selectSupplierProduct"
                    @cancel="supplierProductShow = false" @confirm="confirmSupplierProduct" />
            </van-popup>

            <van-popup v-model="repayModeShow" position="bottom" :overlay="false">
                <van-picker title="还款方式" show-toolbar :columns="repayModes" @cancel="repayModeShow = false"
                    @confirm="confirmRepay" />
            </van-popup>

        </van-popup>

        <van-popup position="bottom" v-model="popupShow" :overlay="true">
            <van-picker title="请选择" show-toolbar :columns="columns"
                        @confirm="onConfirm"
                        @cancel="popupShow=false"/>

        </van-popup>

        <van-popup position="bottom" v-model="popupMultipleShow" :overlay="true">
            <van-picker title="多选"
                        show-toolbar
                        cancel-button-text="关闭"
                        confirm-button-text="选择"
                        :columns="multipleColumns"
                        @confirm="onMultipleSelect"
                        @cancel="onMultipleConfirm"/>

        </van-popup>

        <!--房产信息风控初审填写 -->
        <van-popup
                v-model="mortgageShow"
                position="top"
                custom-style="width: 100%;"
                @confirm="onMultipleSelect">
            <risk-first-mortgage :mortgageId="mortgageId" v-if="mortgageId" :isReadOnly="isReadOnly"> </risk-first-mortgage>
        </van-popup>


    </div>
</template>

<script>

import {dictData} from "@/vue/utils/interviewData";
import { pick, cloneDeep, debounce } from 'lodash'
import { mapGetters } from 'vuex'
import { eventBus } from '../../../../../vue/utils/eventBus'
import FilesUpload from '@/views/home/business/mortgage/files-upload.vue'
import ossUpload from '@/views/component/oss-upload'
import RiskFirstMortgage from './risk-first-mortgage.vue'
import {
    getApplyInfoHouses,
    getCapitalListByCompany,
    getSupplierProduct,
    saveCreditFinal,
    getCreditFinal, auditProcess, getSuitableProduct, getSupplierTree
} from "../../../../../api/loanInfo";
import Dialog from 'vant/es/dialog'
import Vue from "vue";
const repayModeMap = {
    '先息后本(期末付息)': '1',
    '等额本息': '3',
    '不规则还款（10转5等额）': '4',
    '不规则还款（每年还5%本金）': '5',
    '不规则还款（20转5等额）': '205'
}
export default {
    name: 'risk-final',
    props: {
        applyId: {
            type: String,
            default: ''
        }
    },
    components: {
        FilesUpload,
        ossUpload,
        Dialog,
        RiskFirstMortgage
    },
    watch: {

    },
    computed: mapGetters([
        'auditStatus',
        'applyInfo'
    ]),
    data() {
        return {
            field: undefined,
            mortgageShow:false,
            mortgageId:undefined,
            columns: [],
            multipleColumns: [],
            // 单选
            popupShow: false,
            // 多选
            popupMultipleShow: false,
            isReadOnly:false,
            house:[],
            form: {
                currentMortgagePerson: '',
                currentMortgageAmount: '',
                settlementIsRequired: '',
                associatedAdvances: '',
                purposeOfBorrowing: '',
                reasonOfBorrowing: '',
                businessSummaryFactSheet: '',
                mortgagePriority: '', // 抵押顺位
                approveNo: '',
                industry: '',
                domicile: '',
                customerOther: '',
                marriage: '',
                compensate: '',
                children: '',
                marriageOther: '',
                loanGuarantee: '',
                propertyDesc: '',
                source: '',
                isLease: '',
                leaseDesc: '',
                liveWithElderOrChildren: '',
                surveyDesc: '',
                otherProperties: '',
                otherConcerns: '',
                estimatePriceBySL: 0,
                estimatePriceByFgg: 0,
                estimatePriceByFast: 0,
                finalPrice: 0,
                estimatePriceAverage: 0,
                customMortgageRate: 75,
                mortgageRate: 0,
                estimatePrice: 0,
                bankLoanBalance: 0,
                approveAmountLimit: '',
                mortgageRateContract: '',
                approveAmt: '',
                creditAmount: '',
                creditCardAmount: '',
                bankBalanceInBj: '',
                otherAmount: '',
                estimateOther: '',
                debt: '',
                overdue: '',
                moreThan3: '',
                abnormal: '',
                creditOther: '',
                defendant: '',
                plaintiff: '',
                execute: '',
                economy: '',
                judicialOther: '',
                prepay_rule1_month:'',
                prepay_rule1_ratio:'',
                prepay_rule2_month:'',
                prepay_rule2_ratio:'',
                prepay_rule3_month:'',
                prepay_rule3_ratio:'',
                prepay_rule4_month:'',
                prepay_rule4_ratio:'',
                prepay_rule5_month:'',
                notarization: '',
                riskAudit: '',
                audit: '',
                assistantAudit: '',
                operateAudit: ''
            },
            list: [
                { label: '当前抵押权人', ext: 'currentMortgagePerson', info: '' },
                { label: '对应负债余额', ext: 'currentMortgageAmount', info: '' },
                { label: '是否需要结清', ext: 'settlementIsRequired', info: '' },
                { label: '是否关联大橙垫资', ext: 'associatedAdvances', info: '' },
                { label: '借款用途', ext: 'purposeOfBorrowing', info: '' },
                { label: '借款原因', ext: 'reasonOfBorrowing', info: '' },
                { label: '业务概要-情况说明', ext: 'businessSummaryFactSheet', info: '' },

                { label: '批贷金额', ext: 'approveAmt', info: '' },
                { label: '批贷期限', ext: 'approveNo', info: '' },
                { label: '收费标准', ext: 'approveRate', info: '' },
                { label: '是否公证', ext: 'notarization', info: '' },
                { label: '抵押顺位', ext: 'mortgagePriority', info: '' },

                { label: '客户或其他借款人的职业是否为特殊行业', ext: 'industry', info: '' },
                { label: '客户或其他借款人是否为外籍或港澳台居民', ext: 'domicile', info: '' },
                { label: '其他应关注信息', ext: 'customerOther', info: '' },

                { label: '客户及其他借款主体当前婚姻状况', ext: 'marriage', info: '' },
                { label: '客户是否存在离婚补偿义务', ext: 'compensate', info: '' },
                { label: '了解客户是否有子女', ext: 'children', info: '' },
                { label: '其他应关注信息', ext: 'marriageOther', info: '' },

                { label: '世联评估值', ext: 'estimatePriceBySL', info: '' },
                { label: '房估估评估值', ext: 'estimatePriceByFgg', info: '' },
                { label: '快出价', ext: 'estimatePriceByFast', info: '' },
                { label: '综合评估价', ext: 'finalPrice', info: '' },
                { label: '评估平均数', ext: 'estimatePriceAverage', info: '' },
                { label: '放款额度上限', ext: 'approveAmountLimit', info: '' },

                { label: '信贷余额', ext: 'creditAmount', info: '' },
                { label: '信用卡余额', ext: 'creditCardAmount', info: '' },
                { label: '在京备房抵押贷款余额', ext: 'bankBalanceInBj', info: '' },
                { label: '其他负债', ext: 'otherAmount', info: '' },
                { label: '在京备房评估值', ext: 'estimateOther', info: '' },
                { label: '资产负债率(%)', ext: 'debt', info: '' },
                { label: '自定义抵押率', ext: 'customMortgageRate', info: '' },
                { label: '抵押合同抵押率', ext: 'mortgageRateContract', info: '' },
                { label: '客户及共借人是否有当前逾期的情形', ext: 'overdue', info: '' },
                { label: '客户及共借人近一年内是否有超出连3的情况', ext: 'moreThan3', info: '' },
                { label: '是否有呆账、冻结、关注、次级、可疑、代偿等信息', ext: 'abnormal', info: '' },
                { label: '其他应关注信息', ext: 'creditOther', info: '' },
                { label: '客户及共借人是否有涉及借贷纠纷被告', ext: 'defendant', info: '' },
                { label: '客户及共借人是否有涉及借贷纠纷原告', ext: 'plaintiff', info: '' },
                { label: '客户及共借人当前是否有涉诉或被执行信息（非借贷纠纷）', ext: 'execute', info: '' },
                { label: '客户经营主体及关联公司是否有经济纠纷', ext: 'economy', info: '' },
                { label: '其他应关注信息', ext: 'judicialOther', info: '' },
                { label: '提还期限内(含)', ext: 'prepay_rule1_month', info: '' },
                { label: '收取违约金(提前还款金额)的比例', ext: 'prepay_rule1_ratio', info: '' },
                { label: '提还期限内(含)', ext: 'prepay_rule2_month', info: '' },
                { label: '收取违约金(提前还款金额)的比例', ext: 'prepay_rule2_ratio', info: '' },
                { label: '提还期限内(含)', ext: 'prepay_rule3_month', info: '' },
                { label: '收取违约金(提前还款金额)的比例', ext: 'prepay_rule3_ratio', info: '' },
                { label: '提还期限内(含)', ext: 'prepay_rule4_month', info: '' },
                { label: '收取违约金(提前还款金额)的比例', ext: 'prepay_rule4_ratio', info: '' },
                { label: '提还期限超过', ext: 'prepay_rule5_month', info: '' },
                { label: '贷款合同是否申请强执公证', ext: 'notarization', info: '' },
                { label: '风控内勤审核意见；是否需要客户补充其他资料', ext: 'riskAudit', info: '' },
                { label: '审核人的审批意见；是否为附条件审批', ext: 'audit', info: '' },
                { label: '橙易贷专员的审批意见', ext: 'assistantAudit', info: '' },
                { label: '运营后续跟进是否有应注意事项', ext: 'operateAudit', info: '' }
            ],

            activeNames: ['0'],
            read: true,

            mortgageRate: 0,
            estimatePrice:0,
            suitables: [],
            loading: false,
            suitableSelected: [],
            suitableRate: '',
            repayModes: ['先息后本(期末付息)', '等额本息', '不规则还款（10转5等额）', '不规则还款（每年还5%本金）', '不规则还款（20转5等额）'],
            showRiskAudit: false,
            repayModeShow: false,
            suitableShow: false,
            supplierShow: false,
            productCapitalShow: false,
            supplierProductShow: false,
            supplierProductName: '',
            supplierValue: '',
            productCapitalName: '',
            suitableProduct: [],
            supplierData: [], //资金方
            selectSupplier: [],
            selectProduct: [],
            capitalData: [], //资金包
            selectCapital: [],
            supplierProductData: [], //资金产品
            selectSupplierProduct: [],
            remarkErr: '',
            repayModeCn: '',
            commentErr: '',
            approveRateErr: '',
            repayModeErr: '',
            supplierErr: '',
            approveNoErr: '',
            approveAmtErr: '',
            advanceAmountErr: '',
            dayRateErr: '',
            floatRateErr: '',
            creditGradeErr: '',
            creditGradeCn: '',
            riskFinalForm: {
                borrowAmount: '',
                approveAmt: '',
                advanceAmount: '',
                dayRate: '0',
                borrowTerm: '',
                approveNo: '',
                repayMode: '',
                creditGrade: '',
                approveRate: '',
                remark: '',
                floatRate: 0,
                suitableList: ''
            }
        }
    },
    mounted() {
        let self = this
        this.initData()
        this.loadHouses()

        //初始化审批事件
        eventBus.$on('risk-first-trial-audit', function (item) {
            //审批操作
            self.riskFinalAudit(item.status)
        })
        eventBus.$on('goBackToRiskFirstEdit',function () {
            self.mortgageShow=false
            self.mortgageId=null
        })

        if (this.auditStatus == '3') {
            this.read = false
        }
    },
    destroyed() {
        eventBus.$off('risk-first-trial-audit')
    },
    methods: {
        loadHouses() {
            getApplyInfoHouses({applyId: this.applyId}).then(res => {
                if (res.success) {
                    this.house = res.data
                    for (let index = 0; index < this.house.length; index++) {
                        const item = this.house[index]

                        this.list.push({ label: '产权归属', ext: `house_${item.customerHouseId}_propertyDesc`, info: '' })
                        this.list.push({ label: '客户房产来源', ext: `house_${item.customerHouseId}_source`, info: '' })
                        this.list.push({ label: '房产性质', ext: `house_${item.customerHouseId}_quality`, info: '' })
                        this.list.push({ label: '是否出租【合同打印取值】', ext: `house_${item.customerHouseId}_isLease`, info: '' })
                        this.list.push({ label: '出租情况说明', ext: `house_${item.customerHouseId}_lease`, info: '' })
                        this.list.push({ label: '是否有老人或小孩居住', ext: `house_${item.customerHouseId}_live`, info: '' })
                        this.list.push({ label: '下户意见说明', ext: `house_${item.customerHouseId}_survey`, info: '' })
                        this.list.push({ label: '在京有无其他不动产信息', ext: `house_${item.customerHouseId}_only`, info: '' })
                        this.list.push({ label: '其他应关注信息', ext: `house_${item.customerHouseId}_other`, info: '' })

                        this.form[`house_${item.customerHouseId}_propertyDesc`] = ''
                        this.form[`house_${item.customerHouseId}_source`] = ''
                        this.form[`house_${item.customerHouseId}_quality`] = ''
                        this.form[`house_${item.customerHouseId}_isLease`] = ''
                        this.form[`house_${item.customerHouseId}_lease`] = ''
                        this.form[`house_${item.customerHouseId}_live`] = ''
                        this.form[`house_${item.customerHouseId}_survey`] = ''
                        this.form[`house_${item.customerHouseId}_only`] = ''
                        this.form[`house_${item.customerHouseId}_other`] = ''
                    }
                }
            })
        },
        // 计算平均数
        calculateAverage(value, property) {
            console.log(value)
            const properties = ['estimatePriceByFast', 'estimatePriceByFgg', 'estimatePriceBySL']
            let summary = 0
            properties.filter(x => x !== property).forEach(item => {
                console.log(parseFloat(this.form[item] || 0))
                summary += parseFloat(this.form[item] || 0)
            })
            console.log(summary)
            const average = ((parseFloat(summary) + parseFloat(value)) / 3).toFixed(2)
            this.form['estimatePriceAverage'] = average
            console.log(average)
            this.reCalculateLimit(average)
        },
        // 重新计算放款上限
        reCalculateLimit(average) {
            const limit = (((parseFloat(average) * 10000) * (this.form['mortgageRate'] / 100) - (this.form['bankLoanBalance'] || 0)) / 10000).toFixed(2)
            const estimatePrice = (((parseFloat(average) * 10000) * (this.form['mortgageRate'] / 100)) / 10000).toFixed(2)
            this.form['approveAmountLimit'] = limit
            this.form['estimatePrice'] = estimatePrice
            this.estimatePrice = estimatePrice
        },
        calculateLimit(value, property) {
            var estimatePriceAverage = this.form['estimatePriceAverage']

            if (estimatePriceAverage === 0) {
                return false
            }
            let customMortgageRate = this.form['customMortgageRate'] || 75
            let bankLoanBalance = this.form['bankLoanBalance'] || 0

            if (property === 'customMortgageRate') {
                customMortgageRate = value
            } else if (property === 'bankLoanBalance') {
                bankLoanBalance = value
            }
            // 限制：平均价 * 抵押率
            const limit = (((estimatePriceAverage * 10000) * (customMortgageRate / 100) - bankLoanBalance) / 10000).toFixed(2)
            // 贷款对应房产估值
            const _estimatePrice = ((estimatePriceAverage * 10000) / 10000).toFixed(2)
            this.form['approveAmountLimit'] = limit
            this.form['estimatePrice'] = _estimatePrice
            this.estimatePrice = _estimatePrice
        },
        // 计算负债率
        calculateDebt(value, property) {
            // 计算的相关联字段
            let summary = 0
            let denominator = 0
            const summaryProperties = ['approveAmt', 'creditAmount', 'creditCardAmount', 'bankBalanceInBj', 'otherAmount', 'bankLoanBalance']
            if (summaryProperties.includes(property) > 0) {
                summaryProperties.filter(x => x !== property).forEach(item => {
                    summary += parseFloat(this.form[item] || 0)
                })
                summary = summary + value
                const estimatePrice = (this.form['estimatePrice'] || 0) * 10000 // 贷款对应房产估值
                const estimateOther = this.form['estimateOther'] || 0 // 在京备房评估值
                denominator = estimatePrice + estimateOther
            } else {
                // 贷款对应房产估值或者在京备房评估值变动
                summaryProperties.forEach(item => {
                    summary += parseFloat(this.form[item] || 0)
                })
                if (property === 'estimateOther') { // 在京备房评估值变动
                    denominator = value + (this.form['estimatePrice'] || 0) * 10000
                } else if (property === 'estimatePrice') {
                    denominator = value * 10000 + (this.form['estimateOther'] || 0)
                }
            }
            if (denominator !== 0) {
                const debt = ((summary / denominator) * 100).toFixed(2)
                this.form['debt'] = debt
            }
        },
        // 确认选择
        onMultipleConfirm(value) {
            //this.form[this.field] = value
            this.popupMultipleShow = false
        },
        // 确认选择
        onMultipleSelect(value) {
            let _value = this.form[this.field]
            console.log(_value)
            if (_value) {
                this.form[this.field] = _value + ',' + value
            } else {
                this.form[this.field] = value
            }
            this.$toast('当前选择：' + this.form[this.field])
        },
        // 确认选择
        onConfirm(value) {
            console.log(value, this.field, this.form[this.field])
            this.form[this.field] = value
            this.popupShow = false
        },
        // 激活弹出选择器
        showPopup(value) {
            if (!this.isReadOnly) {
                this.field = value
                this.columns = dictData[value]
                this.popupShow = true
                console.log(value, this.field, this.form[this.field])
            }
        },
        // 激活弹出选择器
        showOtherPopup(value, field) {
            if (!this.isReadOnly) {
                this.field = field
                this.columns = dictData[value]
                this.popupShow = true
            }
        },
        // 激活弹出多选选择器
        showMuliplePopup(value) {
            // 赋值对应字段
            if (!this.isReadOnly) {
                this.field = value
                this.multipleColumns = dictData[value]
                this.popupMultipleShow = true
            }
        },
        // 激活弹出时间选择器
        showDatePopup(value) {
            // 赋值对应字段
            if (!this.isReadOnly) {
                this.field = value
                this.showDatePicker = true
            }
        },

        confirmRepay(val, index) {
            this.repayModeShow = false
            this.riskFinalForm.repayMode = repayModeMap[val]
            this.repayModeCn = val
        },
        confirmSupplier(val, index) {
            this.supplierShow = false
            this.riskFinalForm.sourceCompanyName = val
            this.supplierValue = val
            getCapitalListByCompany({pageSize: 100, supplierId: this.supplierData[index].companyId}).then(res => {
                this.capitalData = res.data
                this.selectCapital = res.data.map(item => item.productCapitalName)
            })
            getSupplierProduct({pageSize: 100, supplierId: this.supplierData[index].companyId}).then(res => {
                this.supplierProductData = res.data
                this.selectSupplierProduct = res.data.map(item => item.productName)
            })
        },
        confirmCapital(val, index) {
            this.productCapitalShow = false
            this.productCapitalName = val
            this.riskFinalForm.productCapitalId = this.capitalData[index].productCapitalId
        },
        confirmSuitableProduct(val, index) {
            this.suitableShow = false
            this.suitableRate = val
            this.riskFinalForm.approveRate = this.suitableProduct[index].annualInterestRate
            this.riskFinalForm.nominalRate = this.suitableProduct[index].annualInterestRate
            this.riskFinalForm.productInstanceId = this.suitableProduct[index].id
            this.riskFinalForm.productInstanceName = this.suitableProduct[index].name
        },
        confirmSupplierProduct(val, index) {
            this.supplierProductShow = false
            this.supplierProductName = val
            this.riskFinalForm.supplierProductId = this.supplierProductData[index].productId
        },
        auditRiskFinal(index) {
            if (this.checkAuditForm()) {
                this.loading = true
                if (index == 1) {
                    this.riskFinalForm.nextStep = 'RISK_FINAL_JUDGMENT'
                } else if (index == 2) {
                    this.riskFinalForm.nextStep = 'LOAN_REVIEW_COMMITTEE'
                } else if (index == 3) {
                    this.riskFinalForm.nextStep = 'CONTRACT_GATHER'
                }
                this.riskFinalForm.applyId = this.applyId
                this.riskFinalForm.process = 'RISK_FIRST_TRIAL'
                this.riskFinalForm.type = 'pass'
                auditProcess(this.riskFinalForm).then(res => {
                    this.loading = false
                    this.$toast(res.msg)
                    if (res.success) {
                        if (res.success) {
                            this.$router.go(-1)
                        }
                    }
                })
            }

        },
        checkAuditForm() {
            let flag = true
            if (!this.riskFinalForm.approveAmt) {
                this.approveAmtErr = '请输入审批金额'
                flag = false
            }
            if (!this.riskFinalForm.advanceAmount) {
                this.advanceAmountErr = '请输入本次放款金额'
                flag = false
            }
            if (!this.riskFinalForm.approveNo) {
                this.approveNoErr = '请输入审批期限'
                flag = false
            }
            if (this.applyInfo.productFlag != '1100110' && !this.riskFinalForm.approveRate) {
                this.approveRateErr = '请输入借款年利率'
                flag = false
            }

            if (this.applyInfo.productFlag == '1100110' && !this.riskFinalForm.dayRate) {
                this.dayRateErr = '请输入借款日利率'
                flag = false
            }

            if (!this.riskFinalForm.remark) {
                this.remarkErr = '请输入审批意见'
                flag = false
            }

            if (!flag) {
                this.$toast('审批数据未填写完整')
            }

            return flag
        },
        initData() {
            const self = this
            let params = {
                applyId: this.applyId
            }
            debounce(() => {
                getCreditFinal(params).then(res => {
                    if (res.success) {
                        self.form['finalPrice']=res.data.finalPrice
                        self.form['estimatePrice']=res.data.estimatePrice
                        self.form['mortgageRate']=res.data.mortgageRate
                        self.form['approveAmt']=res.data.approveAmt
                        const labels = res.data.labels
                        const formData = {}
                        labels.forEach((item, index) => {
                            formData[item.ext] = item.info
                        })
                        Object.assign(self.form, formData)
                        self.estimatePrice = self.form.estimatePrice
                        self.mortgageRate = self.form.mortgageRate
                    }
                })
            }, 1000)()
            getSuitableProduct().then(res => {
                this.suitableProduct = res.data
                this.selectProduct = res.data.map(item => item.name + " " + item.annualInterestRate + "%")
            })
            getSupplierTree().then(res => {
                this.supplierData = res.data
                this.selectSupplier = res.data.map(item => item.title)
            })
        },

        riskFinalAudit(status) {
            //保存终审意见
            if (status == '7') {
                this.saveOpinion()
            } else if (status == '6') {
                window.open(this.baseUrl + '/finalAuditReport/index?applyId=' + this.applyId, '_blank ')
            } else if (status == '1') {
                //审核通过
                this.showRiskAudit = true

                //基本信息赋值
                this.riskFinalForm.borrowAmount = this.applyInfo.borrowAmount
                this.riskFinalForm.approveAmt = this.applyInfo.borrowAmount
                this.riskFinalForm.borrowTerm = this.applyInfo.borrowTerm
                this.riskFinalForm.approveRate = this.applyInfo.approveRate
                this.riskFinalForm.approveNo = this.applyInfo.borrowTerm
                this.riskFinalForm.advanceAmount = this.applyInfo.borrowAmount

                //处理还款方式
                this.riskFinalForm.repayMode = this.applyInfo.repayMode
                this.repayModeCn = this.applyInfo.repayModeCn
            }
        },
        saveOpinion() {
            const self = this
            const params = cloneDeep(this.form)
            params.applyId = this.applyInfo.applyId
            const {estimatePriceBySL, estimatePriceByFgg, estimatePriceByFast, finalPrice} = params

            if (parseFloat(finalPrice) === 0) {
                this.$toast('请填写字段【终合评估价】的值')
                return false
            }

            const totalEstimatePriceBySL = parseFloat(this.house.reduce((v, t) => {
                v = v + (t.pgPrice || 0.0)
                return v
            }, 0.0).toFixed(2))
            if (parseFloat(estimatePriceBySL).toFixed(2) !== totalEstimatePriceBySL.toFixed(2)) {
                this.$toast('字段【世联评估价】与房产信息的【世联评估价】之和不匹配，请检查或编辑房产信息的【世联评估价】')
                return false
            }
            // 房产终合评估价合计
            const totalFinalPrice = parseFloat(this.house.reduce((v, t) => {
                v = v + (t.finalPrice || 0.0)
                return v
            }, 0.0).toFixed(2))
            if (parseFloat(finalPrice).toFixed(2) !== totalFinalPrice.toFixed(2)) {
                this.$toast('字段【终合评估价】与房产信息的【最终评估价】之和不匹配，请检查或编辑房产信息的【最终评估价】')
                return false
            }
            this.list.forEach(item => {
                item.info = params[item.ext]
            })
            const data = {applyId: this.applyInfo.applyId}
            data.list = this.list
            data.mortgageRate = params.mortgageRate
            data.estimatePrice = params.estimatePriceAverage
            data.approveAmt = params.approveAmt
            data.bankLoanBalance = params.bankLoanBalance
            data.finalPrice = finalPrice
            self.loading = true
            // 处理list
            saveCreditFinal(data).then(res => {
                self.loading = false
                this.$toast.clear()
                this.$toast(res.msg)
            })
        },
        handleSaveCache () {
            const self = this
            Dialog.confirm({
                title: '警告',
                message: '保存会覆盖当前单上一次的缓存内容！',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnClickOverlay: true,
            }) .then(() => {
                    // 确定按钮的操作
                    const values = self.form;
                    const key = 'fdzsCache_' + self.applyInfo.applyNum;
                    Vue.ls.set(key, values, 1000 * 60 * 60 * 24 * 5); // 保存缓存内容
                  this.$toast('已保存');
                })
                .catch(() => {
                    // 取消按钮的操作
                });
        },
        handleLoadCache () {
            const self = this;
            const fdzsCache =Vue.ls.get('fdzsCache_' + this.applyInfo.applyNum);
            if (fdzsCache == null) {
                this.$toast('当前进件单没有缓存初审意见数据');
            } else {
                Dialog.confirm({
                    title: '警告',
                    message: '读取临时缓存内容会覆盖当前表单！',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    closeOnClickOverlay: true,
                })
                    .then(() => {
                        // 确定按钮的操作
                        self.form=fdzsCache;
                        this.$toast('已读取内容到当前初审意见表单');
                    })
                    .catch(() => {
                        // 取消按钮的操作，无需实现具体内容
                    });
            }
        },
        handleEdit(house){
            this.mortgageShow=true
            this.mortgageId=house.customerHouseId
        }
    }

}
</script>

<style scoped></style>
